module.exports = __webpack_public_path__ + "media/images/lp_v6_02-6b07bfffc56b35a395ca8c07018560a8.webp";